import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { KEYS } from "../constants/keys";
import { EMPTY, throwError } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { inject } from "@angular/core";
import { SessionTimerService } from "./session-timer.service";

export const jwttokeninterceptor: HttpInterceptorFn = (req: any, next) => {
    let excludeUrls: string[] = ['userlogin', 'adminlogin', '/AuthenticateSignIn', '/registerJobSeeker','/checkJobseekerAccount', 'upload.php', 'ipinfo.io',
        'ResetPassword', 'api.sam.gov', '/pgrooms/', 'qualcheckers.com', 'translation.googleapis.com', 'mailto:', 'onedriveUpload.php', 'SharedDriveUpload.php'];
    let isLoggedOut = false;

    const authService = inject(AuthService);
    const sessionTimer = inject(SessionTimerService);

    const toSkip = excludeUrls.some(url => req.url.includes(url));

    let clonedReq;

    if (toSkip) {
        clonedReq = req;
    } else {
        const token = sessionStorage.getItem(KEYS.api_token);

        if (token) {
            clonedReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        } else { clonedReq = req; }
    }

    return next(clonedReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !isLoggedOut) {
                if (authService.isTokenExpired()) {
                    console.log("Token expired");
                    try {
                        const sessionDuration = sessionTimer.stopTimer();
                    } catch { }
                    isLoggedOut = authService.tokenSignOut();
                } else {
                    console.warn('401 received but token not expired');
                }
            }
            return throwError(() => error);
        })
    );

};